var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 397 c-16 -16 -14 -57 4 -57 8 0 15 9 15 20 0 20 5 21 83 18 l82 -3 3 -137 3 -138 -86 0 -85 0 0 100 c0 82 -3 100 -15 100 -12 0 -15 -18 -15 -103 0 -67 4 -107 12 -115 7 -7 43 -12 90 -12 45 0 87 -5 98 -12 16 -10 24 -10 40 0 11 7 53 12 99 12 85 0 105 10 99 52 -4 30 -22 30 -26 1 -3 -22 -8 -23 -88 -23 l-85 0 3 138 3 137 83 3 82 3 0 -91 c0 -73 3 -90 15 -90 12 0 15 17 15 94 0 64 -4 97 -13 104 -18 15 -400 15 -416 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 328 c-20 -28 -20 -62 -1 -78 9 -7 15 -29 15 -54 0 -22 5 -48 10 -56 9 -13 11 -13 20 0 5 8 10 34 10 56 0 25 6 47 15 54 31 26 5 100 -35 100 -10 0 -26 -10 -34 -22z m49 -29 c9 -26 -10 -48 -26 -32 -12 12 -3 53 11 53 5 0 12 -9 15 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 311 c0 -16 19 -23 40 -16 30 10 24 25 -10 25 -16 0 -30 -4 -30 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 310 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 241 c0 -16 19 -23 40 -16 30 10 24 25 -10 25 -16 0 -30 -4 -30 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 240 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 171 c0 -16 19 -23 40 -16 30 10 24 25 -10 25 -16 0 -30 -4 -30 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 170 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d41b79239e143c5ccd541d3e3d2b244f.svg";
export { ForwardRef as ReactComponent };